module.exports = __webpack_public_path__ + "img/rankster-logo-square.1097303d.png";